import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const AccordeonWrapper = styled.div`
    flex-direction: column;
    width: 100%;
    padding: 24px;
    background: ${COLORS.white};
    border-radius: 16px;
`;

export const Title = styled.div<{ isOpen: boolean, isPromoted: boolean }>`
    position: relative;
    width: 100%;
    color: ${COLORS.black};
    font-size: 20px;
    line-height: 1.4;
    padding-left: ${p => p.isPromoted ? '28px' : '0'};
    cursor: pointer;

    &:after {
        content: '';
        position: absolute;
        width: 14px;
        height: 8px;
        right: 0;
        top: 50%;
        transform: ${p => p.isOpen ? 'rotate(180deg) translate(-50%, 50%)' : 'translateY(-50%)'};
        background: url(${require('~/static/images/menu/arrow.svg')}) no-repeat right;
    }
`;

export const PromoIcon = styled.div`
    position: absolute;
    top: 7px;
    left: 5px;
    width: 17px;
    height: 14px;
    background: url('${require('~/static/images/menu/promo.svg')}') center / cover no-repeat;
`;

export const Content = styled.div<{ isOpen: boolean, withDesc: boolean }>`
    width: 100%;
    flex-direction: column;
    max-height: ${props => props.isOpen ? '100%' : '0'};
    padding-top: ${p => p.isOpen ? (p.withDesc ? '4px' : '24px') : '0'};
    overflow: hidden;
    transition: max-height 0.05s ${props => props.isOpen ? 'ease-in' : 'ease-out'};
`;

export const Subtitle = styled.p``;

export const Description = styled.p`
    width: 100%;
    font-size: 12px;
    line-height: 1.33;
    color: ${COLORS.darkGrey};
    margin-bottom: 24px;
`;

export const ChildItem = styled.div`
    width: 100%;

    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const ChildLink = styled.a`
    display: block;
    width: 100%;
    color: ${COLORS.black};
    font-size: 14px;
    line-height: 1.14;
    transition: color 0.3s ease;
    white-space: pre-wrap;
`;
